import { render } from "./Privat24.vue?vue&type=template&id=447d781c&scoped=true"
const script = {}

import "./Privat24.vue?vue&type=style&index=0&id=447d781c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-447d781c"],['__file',"src/icons/Privat24.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "447d781c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('447d781c', __exports__)) {
    api.reload('447d781c', __exports__)
  }
  
  module.hot.accept("./Privat24.vue?vue&type=template&id=447d781c&scoped=true", () => {
    api.rerender('447d781c', render)
  })

}


export default __exports__